import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_API_URL } from '../../api/config';
import ENDPOINTS from '../../api/endPoints';
import {
  fetchMenuEnhancementRequest,
  fetchMenuEnhancementSuccess,
  fetchMenuEnhancementFailure,
} from '../slices/menuEnhancementSlice';
import type { MenuEnhancementResponse } from '../../components/menuEnhancement/types';

function* fetchMenuEnhancementSaga(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const restaurantId = action.payload;
    const url = `${ENDPOINTS.menu_suggestions}/${restaurantId}`;
    const response = yield call(axios.get, url);

    const data: MenuEnhancementResponse = response.data;
    
    yield put(fetchMenuEnhancementSuccess({
      suggestions: data.data,
      count: data.count,
    }));
  } catch (error: any) {
    yield put(
      fetchMenuEnhancementFailure(
        error.response?.data?.message || error.message || 'Failed to fetch menu enhancement'
      )
    );
  }
}

export function* menuEnhancementSaga() {
  yield takeLatest(fetchMenuEnhancementRequest.type, fetchMenuEnhancementSaga);
}
